export default __webpack_public_path__ + "static/media/taisat.a7b26417.png";